import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import { Multiselect } from "multiselect-react-dropdown";
import ContestDetails from "./ContestDetails";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import AcceptedUserList from "./AcceptedUserList";
import AllocatedUserList from "./AllocatedUserList";
import RoomIdPassword from "./RoomIdPassword";
import RoomIdPasswordReset from "./RoomIdPasswordReset";
import TotalJoinedPlayers from "./TotalJoinedPlayers";
import DropdownReactSelect from "../../components/DropdownReactSelect";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar,
  DatePickerField,
  TimePickerField,
  Select,
  Input,
} from "../../../_metronic/_partials/controls";

import MultiUpload from "../../components/upload/MultiUpload";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import { NotificationContainer, NotificationManager } from "react-notifications";

import { Formik, Form, Field, FieldArray } from "formik";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import * as UIHelpers from "../../components/UIHelpers";

import { Accordion, Button } from "react-bootstrap";

import TournamentAddMatches from "./TournamentAddMatches";

const TournamentContest = (props) => {
  const dispatch = useDispatch();

  const { currentState } = useSelector(
      (state) => ({ currentState: state.tournamentsSlice }),
      shallowEqual
  );

  const {
    actionsLoading,
    contestData
  } = currentState;

  const [contestDateTime, setContestDateTime] = useState(undefined);
  const [isResidualMatch, setIsResidualMatch] = useState(false);
  const [isResetRoomIdPassword, setIsResetRoomIdPassword] = useState(false);
  const [isCancelContest, setIsCancelContest] = useState(false);
  const [isResidualMatchBtnShow, setIsResidualMatchBtnShow] = useState(true);

  const [file, setFile] = useState([]);

  const [frmInitialValues, setFrmInitialValues] = useState(
    {
        roomId: '',
        roomPassword: '',
        steamLink: '',
        numberOfPlayedUsers: 0,
        isActive: true,
        date: null,
        time: null,
    }
  );

  const [contestTime, setContestTime] = useState();
  const [ssuploadTime, setSsuploadTime] = useState();

  const [contestGameType, setContestGameType] = useState(1);

  const [cancelReasonDropdownFilterData, setCancelReasonDropdownFilterData] = useState([]);
  const [cancelReasonSelectedDropdownFilterData, setCancelReasonSelectedDropdownFilterData] = useState(null);

  const formate = 'YYYY-MM-DD HH:mm:ss';

  const onUpdateFileValue = (file, name) => {
    console.log("file", file)
    console.log("name", name)
  }

  useEffect(() => {
    if (contestData && contestData?.data && contestData?.data?.matchTime) {
      const date = moment(contestData?.data?.matchDate).format("y-MM-DD");
      const time = moment(contestData?.data?.matchTime).format("HH:mm:ss");
      const formate = "YYYY-MM-DD h:m A";
      // var dateTime = new Date(date + ' ' + time);
      var dateTime = moment(date + " " + time);
      setContestDateTime(dateTime);
    }
  
    let totalPlayers = 0, gameTypePlayer = 1;
    if (
      contestData?.data?.gameTypeAry
    ) {
      gameTypePlayer = contestData.data.gameTypeAry.players;
    }

    if(contestData?.data?.isResetRoomPassword && contestData?.data?.isResetRoomPassword == true)
    {
      setIsResetRoomIdPassword(true);
    }

    if(contestData?.data?.gameAry?.settings?.cancellationReason && contestData?.data?.gameAry?.settings.cancellationReason.length > 0)
    {
      let temp = [];
      contestData.data.gameAry.settings.cancellationReason.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element,
          value: element,
        })
      });
      setCancelReasonDropdownFilterData(temp);
    }

    if(contestData?.data?.gameTypeAry && contestData?.data?.gameTypeAry)
    {
      setContestGameType(contestData.data.gameTypeAry.players);
    }

    setFrmInitialValues({
      date: contestData?.data?.matchDate,
      time: contestData?.data?.matchTime,
    })

    if (contestData && contestData?.data) {
      const date = moment(contestData.data.matchDate).format('y-MM-DD');
      const time = moment(contestData.data.matchTime).format('HH:mm:ss');
      var dateTime = moment(contestData.data.dateTime);

      const currentTime = moment();
      const startTime = moment(moment(dateTime), formate);
      const SSEndTime = moment(moment(dateTime).add(contestData.data.gameTypeAry.settings.SSUploadTime, 'minutes'), formate);

      let gameContestTime = moment(contestData?.data?.dateTime).format(formate)
      let gameIdSSUploadTimeTime = moment(contestData?.data?.dateTime)
        .add(contestData?.data?.gameTypeAry?.settings?.SSUploadTime, 'minutes')
        .format(formate)

      let now = moment().format(formate)

      setContestTime(gameContestTime)
      setSsuploadTime(gameIdSSUploadTimeTime)
    }

  }, [contestData]);

  const validateDateTime = (value) => {
    let error;
    if (!value) {
        error = 'Required';
    }
    return error;
  }

  const reloadLocation = () => {
    window.location.reload();
  };

  const ResetRoomIdPass = (values) => {
    let payload = {
      _id: contestData?.data._id
    };
    setIsResetRoomIdPassword(true);
    if (contestData?.data._id) {
      dispatch(actions.resetRoomIdPassword(payload)).then((sucess) => sucess ? reloadLocation() : null);
    }
  }

  const RescheduleMatchUpdate = (values) => {
    if(contestData?.data?.status != "completed" && contestData?.data?.status != "review" && contestData?.data?.status != "cancelled")
    {
      if (!values.date || !values.time) {
          NotificationManager.error('Please select Date and Time', 'Error');
      } else {
          let payload = {
              _id: contestData?.data._id,
              date: values.date,
              time: values.time,
              
          }
          if (contestData?.data._id) {
            dispatch(actions.rescheduleContest(payload)).then((sucess) => sucess ? reloadLocation() : null);
          }
      }
    }
    else
    {
      NotificationManager.error('Sorry, you can not reschedule this contest!', 'Error');
    }
  }

  const CancelMatchUpdate = (values) => {
    if(contestData?.data?.status != "cancelled")
    {
      if (cancelReasonSelectedDropdownFilterData != null) {
        let payload = {
          _id: contestData?.data._id,
          cancelReason: cancelReasonSelectedDropdownFilterData.value,
        }
          
        if (contestData?.data._id) {
          dispatch(actions.cancelContest(payload)).then((sucess) => sucess ? reloadLocation() : null);
        }
      } else {
        NotificationManager.error('Please Select Reason', 'Error');
      }
    }
    else
    {
      NotificationManager.error('Sorry, you can not reschedule this contest!', 'Error');
    }
  }

  const onClickItem = (e,name) => {
    var link = document.createElement('a');
    link.href = e;
    link.download = true;
    document.body.appendChild(link);
    link.click();
  }

  const saveScreenShot = () => {
    if(contestGameType > 1)
    {
      // if(contestData?.data?.teamSlotAdd && contestData.data.teamSlotAdd > 0){
        if (!file || (file && file.length === 0)) {
          NotificationManager.error('Please upload winning screenshort!', 'Error');
        }
        else {
          let tempArray = []
          tempArray.push(currentState.upload)

          let payload = {}
          payload.id = contestData?.data._id
          payload.screenshotImages = file

          if (contestData?.data._id) {
            dispatch(actions.saveScreenShotImages(payload)).then((sucess) => sucess && sucess != undefined ? reloadLocation() : null);
          }
        }
      // }
      // else {
      //   NotificationManager.error('Please update team slots first.!!', 'Error');
      // }
    }
    else
    {
      if (!file || (file && file.length === 0)) {
        NotificationManager.error('Please upload winning screenshort!', 'Error');
      }
      else {
        let tempArray = []
        tempArray.push(currentState.upload)

        let payload = {}
        payload.id = contestData?.data._id
        payload.screenshotImages = file
        if (contestData?.data._id) {
          dispatch(actions.saveScreenShotImages(payload)).then((sucess) => sucess && sucess != undefined ? reloadLocation() : null);
        }
      }
    }
  }

  const ResetSSUC = (values) => {
    let payload = {
        _id: contestData?.data._id       
    };
    if (contestData?.data._id) {
        dispatch(actions.resetScreenShotImage(payload)).then((sucess) => sucess ? reloadLocation() : null);
    }
  }

  return (
    <>
      <NotificationContainer />
      <ContestDetails />
      {!isResetRoomIdPassword ? 
        <RoomIdPassword contestData={contestData} />
        : <></> }
      {isResetRoomIdPassword ? 
      <RoomIdPasswordReset
        contestData={contestData}
      /> : <></> }

      {
        (contestData?.data?.roomId != "" && contestData?.data?.password != "" && moment().format(formate) > contestTime && moment().format(formate) < ssuploadTime) && contestData?.data?.status != "cancelled" && contestData?.data?.ssUpload.length == 0 ?
          <Col lg={24} md={24} sm={24} xs={24} className="mb-4">
            <Card>
              <CardHeader title={'Upload winning Screenshots'}></CardHeader>
              <CardBody>
               {
                  contestData?.data?.ssUpload && contestData?.data?.ssUpload.length > 0 ?
                    <Carousel>
                      {contestData?.data?.ssUpload.map((tmgData, key) => {
                        return (
                          <img src={`${UIHelpers.imageUrl}${tmgData?.default}`} width={25} onClick={() => onClickItem(`${UIHelpers.imageUrl}${tmgData?.default}`)} />
                        )
                      })}
                    </Carousel>
                    :
                    <>
                      {/* <input type="file" name="file" onChange={uploadImage} accept=".png, .jpg, .jpeg" />
                      <div className="col-md-12 text-right">
                        {currentState.upload?.default ? <button type="button" onClick={() => saveScreenShot()} className="btn mt-20m btn-primary">Save</button> : <></> }
                      </div> */}
                      <Formik>
                      <Form>
                        <Field
                          name="screenshotImage"
                          component={MultiUpload}
                          file={file}
                          onfileValueSet={onUpdateFileValue}
                        />
                        <div className="col-md-12 text-right">
                          <button type="button" onClick={() => saveScreenShot()} className="btn mt-20m btn-primary">Save</button>
                        </div>
                        </Form>
                      </Formik>
                    </>
                }
              </CardBody>
            </Card>
          </Col>
          :
          <></>
      }

      {
        contestData?.data?.ssUpload && contestData?.data?.ssUpload.length > 0 ?
          <Col lg={24} md={24} sm={24} xs={24} className="mb-4">
            <Card>
              <CardHeader title={'Upload winning Screenshots 1'}></CardHeader>
              <CardBody>
                <Carousel>
                  {contestData?.data?.ssUpload.map((tmgData, key) => {
                    return (
                      <div onClick={() => onClickItem(`${UIHelpers.imageUrl}${tmgData?.default}`)}>
                      <img src={`${UIHelpers.imageUrl}${tmgData?.default}`} width={25} onClick={() => onClickItem(`${UIHelpers.imageUrl}${tmgData?.default}`)} />
                      </div>
                    )
                  })}
                </Carousel>
              </CardBody>
            </Card>
          </Col>
        :
        <></>
      }

      <TotalJoinedPlayers contestData={contestData} />

      {contestData?.data?.status === "waiting" || contestData?.data?.status === "started" ? (
        <>
          <AcceptedUserList />
        </>
      ) : <></>}

      {/* <AcceptedUserList /> */}

      <AllocatedUserList/>

      <Formik
        enableReinitialize={true}
        initialValues={frmInitialValues}
        onSubmit={(values) => {
          RescheduleMatchUpdate(values);
        }}
      >
        {({ handleSubmit, errors, values, setFieldValue, validateField, validateForm }) => (
            <Form className="form form-label-right w-100"> 
              <Row className="fixed Button">
                <div className="col-md-12">
                  {contestData?.data?.status !== "cancelled" && contestData?.data?.status !== "completed" && (
                  <>
                  { helperFunc.isButtonAccess("contest.rescheduleMatch.other")&&( !isResidualMatch && (
                            <button
                              type="button"
                              className="btn btn-primary font-weight-bolder text-uppercase mr-3"
                              onClick={() => setIsResidualMatch(true)}
                            >
                              RESCHEDULE MATCH
                            </button>
                          ))}

                    {isResidualMatch && (
                      <Card>
                        <CardHeader title="RESCHEDULE MATCH"></CardHeader>
                        <CardBody>
                          <div className="row">
                            <div className="col-lg-6">
                              <DatePickerField
                                label="Contest Date"
                                name="date"
                                format={'DD-MM-YYYY'}
                                validate={validateDateTime}
                                minDate={moment(contestData?.data?.tournamentAry.startDate)}
                                maxDate={moment(contestData?.data?.tournamentAry.endDate)}
                              />
                            </div>
                            <div className="col-lg-6">
                              <TimePickerField
                                label="Time"
                                name="time"
                                validate={validateDateTime}
                                // minDate={moment(contestData?.data?.tournamentAry.startDate)}
                                maxDate={moment(contestData?.data?.tournamentAry.endDate)}
                              />
                            </div>
                          </div>
                        </CardBody>

                        <CardFooter>
                          <Col lg={12} className="text-right">
                            <button type="button" className="btn btn-primary font-weight-bolder text-uppercase mr-3" onClick={() => RescheduleMatchUpdate(values)} >RESCHEDULE MATCH</button>
                          </Col>
                        </CardFooter>
                      </Card>
                    )}
                  </>
                  )}

                  {contestData?.data?.status !== "cancelled" && contestData?.data?.status !== "completed" && (
                    <button type="button" className="btn btn-primary font-weight-bolder text-uppercase mr-3" onClick={() => ResetRoomIdPass(values)}>Reset RoomId & Password </button>
                  )}

                  {contestData?.data?.status === "review" && (
                    <button type="button" className="btn btn-primary font-weight-bolder text-uppercase mr-3" onClick={() => ResetSSUC(values)}>Reset Screenshorts & User Count </button>
                  )}

                  {contestData?.data?.status !== "cancelled" && contestData?.data?.status !== "completed" && (
                    <>
                    {!isCancelContest ?
                      <button type="button" className="btn btn-primary font-weight-bolder text-uppercase mr-3" onClick={() => setIsCancelContest(true)}>Cancel Contest </button> : ""
                    }
                    {
                      isCancelContest ?
                        <Card>
                          <CardHeader title="CANCEL MATCH"></CardHeader>
                          <CardBody>
                              <div className="row">
                                  <div className="col-sm-6">
                                  <DropdownReactSelect
                                    placeholder={'Select...'}
                                    name={'cancelReason'}
                                    value={cancelReasonSelectedDropdownFilterData}
                                    isMulti={false}
                                    isClearable={true}
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    options={cancelReasonDropdownFilterData}
                                    onChange={setCancelReasonSelectedDropdownFilterData}
                                  />
                                  </div>
                              </div>
                          </CardBody>
                          <CardFooter>
                            <Col lg={12} className="text-right">
                                <button type="button" className="btn btn-primary font-weight-bolder text-uppercase mr-3" onClick={() => CancelMatchUpdate(values)} >CANCEL MATCH</button>
                            </Col>
                          </CardFooter>:""
                      </Card>
                      : ""
                    }
                    </>
                  )}
                </div>
              </Row>
            </Form>
          )}
      </Formik>
    </>
  )
}

export default TournamentContest;